import cn from '../../../utils/cn';
import { isEmpty } from 'lodash';

const containerClass = ({ inline, disabled, state, className }) =>
  cn({
    'mb-2.5': true,
    'flex flex-row flex-nowrap': inline,
    'opacity-50': disabled,
    'w-50': true,
    'border-b-0 rounded-b-none': state.isOpen,
  }, className);

const labelClass = ({ labelClassName, state, inline, hideLabel }) =>
  cn({
    'block mb-1 capitalize text-xs font-regular-font tracking-wide font-semibold leading-4': true,
    [labelClassName]: !isEmpty(labelClassName),
    'sr-only': hideLabel,
    'pt-2.5 mr-2.5': inline,
    'text-dark-grey': !state.hasError,
    'text-red': state.hasError || state.showRequiredError,
  });

const dropDownClass = ({ state }) =>
  cn({
    'w-60 absolute z-50 p-2 border border-action-blue bg-white rounded mt-2': true,
    'block': state.isOpen,
    'hidden': !state.isOpen,
  });

const inputClass = ({ state }) =>
  cn({
    'w-50 pl-2 pr-9 h-9': true,
    'text-brand-blue text-sm font-regular-font placeholder-medium-grey': true,
    'lowercase': !state.errorMessage,
    'border rounded bg-white hover:bg-medium-fill-grey': true,
    'rounded': !state.isOpen,
    'border-light-border-blue': !state.hasError && !state.isOpen,
    'border-action-blue': !state.hasError && state.isOpen,
    'border-red': state.hasError || state.showRequiredError,
  });

export {
  containerClass,
  labelClass,
  dropDownClass,
  inputClass,
};
